import React, { useState, createContext, useContext } from 'react';
import type { ReactNode } from 'react';
type Language = 'en' | 'es';
interface LanguageContextType {
  lang: Language;
  toggleLang: () => void;
  setLang: (lang: Language) => void;
}
const LanguageContext = createContext<LanguageContextType | undefined>(undefined);
export const LanguageProvider = ({
  children
}: {
  children: ReactNode;
}) => {
  const [lang, setLang] = useState<Language>('es');
  const toggleLang = () => {
    setLang(prev => prev === 'en' ? 'es' : 'en');
  };
  return <LanguageContext.Provider value={{
    lang,
    toggleLang,
    setLang
  }} data-id="element-160" data-mp="xm28c6xszypv">
      {children}
    </LanguageContext.Provider>;
};
export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (context === undefined) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};